import { render } from "./KitDetails.vue?vue&type=template&id=e2781d26&scoped=true"
import script from "./KitDetails.vue?vue&type=script&lang=js"
export * from "./KitDetails.vue?vue&type=script&lang=js"

import "./KitDetails.vue?vue&type=style&index=0&id=e2781d26&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e2781d26"

export default script